import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DataService} from '../services/data.service';
import {isNullOrUndefined} from '../shared/is-null-or-undefined';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
    @Input() isOpen = false;
    @Output() navigationSelected = new EventEmitter<void>();

    isDispatcherUser = false;
    isAdminUser = false;
    isDispatcherManager = false;

    constructor(private dataService: DataService) { /* noop */
    }

    ngOnInit() {
        this.checkIfDispatcherUser();
        this.dataService.dataChangedSession.subscribe(() => {

            this.checkIfDispatcherUser();
        });
    }

    checkIfDispatcherUser() {
        const userData = this.dataService.getUserInfo();
        if (!isNullOrUndefined(userData) && !isNullOrUndefined(userData.Permissions)) {
            if (userData.Permissions.includes('isdispatcheruser')) {
                this.isDispatcherUser = true;
            } else if (userData.Permissions.includes('isdispatchermanager')) {
                this.isDispatcherManager = true;
            } else {
                this.isAdminUser = true;
            }
        }
    }

    handleNavigationClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        if (!isNullOrUndefined(target) && !isNullOrUndefined(target.closest('.nav-link'))) {
            this.navigationSelected.emit();
        }
    }
}
